/* WJW Increment 58: initialize the native Flits product button in dynamic Quick Shop.
   The button and wishlist network requests remain owned by Flits. */
(function () {
  'use strict';
  var observer = null;
  var retries = [];
  function drawerActive() {
    return window.innerWidth <= 749 && document.querySelector('#Product-Drawer.active');
  }
  function nativeButton() {
    var drawer = drawerActive();
    if (!drawer) return null;
    /* The existing comp_wishlistProdcutButton is rendered by product-add-to-cart. */
    var holder = drawer.querySelector('.product-add-to-cart-container #flits-wishlist-dom, .product-add-to-cart-container .wjw-inc58-native-flits');
    if (!holder) return null;
    var button = holder.querySelector('a.flits-wls-button[data-flits-product-id][data-flits-product-handle]');
    return button ? {holder: holder, button: button} : null;
  }
  function sync() {
    var native = nativeButton();
    if (!native) return;
    var Flits = window.Flits;
    /* Native wishlist script MUST be installed. Do not show a false CTA. */
    if (typeof Flits !== 'function' || !Flits.wishlistButton ||
        !Flits.wishlistButton.settings || typeof Flits.isProductAddedInWishlist !== 'function' ||
        typeof Flits.fn?.animateWishlistButton !== 'function') return;
    var holder = native.holder;
    var button = native.button;
    var handle = button.getAttribute('data-flits-product-handle');
    var id = button.getAttribute('data-flits-product-id');
    if (!handle || !/^\d+$/.test(id || '')) return;
    /* Flits initializes this template for PDP on initial load only. For Quick Shop,
       use that same template and Flits' document-level delegated click handler. */
    if (!holder.classList.contains('wjw-inc58-native-flits')) {
      holder.removeAttribute('id'); // prevent collision with Flits global template
      holder.classList.add('wjw-inc58-native-flits');
    }
    var wished = Boolean(Flits.isProductAddedInWishlist(handle));
    var active = button.classList.contains('flits-wls-active');
    if (wished !== active) {
      Flits(button).animateWishlistButton(-1, wished
        ? Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Added to Favorites')
        : Flits.t('Flits.locals.wishlisted_product_page.add_to_wishlist_button', 'Add to Favorites'));
    }
    holder.style.display = 'flex';
    holder.classList.add('wjw-inc57-quickshop-flits-ready');
  }
  function clearRetries() {
    retries.forEach(clearTimeout); retries = [];
    if (observer) { observer.disconnect(); observer = null; }
  }
  function onOpen() {
    clearRetries();
    sync();
    /* Flits loads asynchronously and its JQuery event is not a DOM event. */
    [150, 400, 800, 1600, 3000, 5000, 8500].forEach(function(ms) {
      retries.push(setTimeout(sync, ms));
    });
    var drawer = drawerActive();
    var content = drawer && drawer.querySelector('#Product-Drawer-Content');
    if (content && window.MutationObserver) {
      observer = new MutationObserver(function() { sync(); });
      observer.observe(content, {childList: true, subtree: true});
      retries.push(setTimeout(function() { if (observer) observer.disconnect(); observer = null; }, 9000));
    }
  }
  document.addEventListener('quick-view:open', onOpen);
  document.addEventListener('quick-view:close', clearRetries);
  /* Flits click handler itself is responsible for all requests and state changes. */
})();
